export const vacancyWeek = (state = [], action) => {
  switch (action.type) {
      case "VACANCY_WEEK": {
          return action.payload.vacancyWeek;
      }
      default: {
          return state;
      }
  }
};